import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import formAppLayoutPosterMatrixComponent from './formAppLayoutPosterMatrixComponent';

export default {
  title: 'API Urls',
  attributeName: 'appLayout',
  helpText: 'This section is to control how many and what content will appear in the Room. It can be reorganized into different forms',
  fields: [
      {
      attributeName: 'clientAPIUrl',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      disabled:true,
      label:'Client API Url',
      helpText:"",
    },
    {
      attributeName: 'spacesAPIUrl',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      disabled:true,
      label:'Spaces API Url',
      helpText: '',
    },
  ],
};

